import {
  EmailAnalysisBranch,
  EmailAnalysisDraft,
  EmailAnalysisEmail,
  EmailAnalysisResult,
  EmailAnalysisTabType,
} from "@types";

export interface SimulatorState {
  isLoading: {
    simulateDraft: boolean;
  };
  isError: {
    simulateDraft: boolean;
    permissionError: boolean;
    recipientsError: boolean;
  };
  activeTabId: EmailAnalysisTabType;
  result: EmailAnalysisResult | null;
  selectedBranch: EmailAnalysisBranch | null;
  selectedEmail: EmailAnalysisEmail | EmailAnalysisDraft | null;
  currentDraftState: string | null;
  threadId: string | null;
  threadTrackStatus: boolean | null;
}
